module.exports = __webpack_public_path__ + "static/finelite_hero_bg-748426a9760519427b7a795fcb83ccb5.png";